import { render, staticRenderFns } from "./ModalEmpresa.vue?vue&type=template&id=ac7b1096&lang=pug"
import script from "./ModalEmpresa.vue?vue&type=script&lang=js"
export * from "./ModalEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports